import type { BridgeRoom, BridgeTaskDetail } from '@/features/bridge';
import type { RootState } from '@/rootState';

export const getUserId = ({ sharedReducer: { userData } }: RootState): number =>
	Number(userData.id);

export const getIsBridgePlaylist = ({ playlistReducer }: RootState): boolean =>
	playlistReducer.isBridgePlaylist;

export const getPersonalityQuizAnswerIds = ({ playlistReducer }: RootState): number[] =>
	playlistReducer.personalityQuizAnswerIds;

export const getBridgeRoom = ({ bridgeReducer }: RootState): BridgeRoom | null =>
	bridgeReducer.room;

export const getBridgeTask = ({ bridgeReducer }: RootState): BridgeTaskDetail | null =>
	bridgeReducer.task as BridgeTaskDetail | null;
